import { render, staticRenderFns } from "./SellerProduct.vue?vue&type=template&id=4c1747ad&scoped=true&"
import script from "./SellerProduct.vue?vue&type=script&lang=js&"
export * from "./SellerProduct.vue?vue&type=script&lang=js&"
import style0 from "./SellerProduct.vue?vue&type=style&index=0&id=4c1747ad&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1747ad",
  null
  
)

export default component.exports